<template>
  <md-dialog :md-active.sync="showEdiAjustDest" :md-click-outside-to-close="false" class="custom-dialog">
    <md-dialog-title class="dialog-header">
      <span class="header-title">{{ labels.title }}</span>
    </md-dialog-title>
    
    <md-dialog-content class="dialog-content">
      <!-- Campos de búsqueda (solo para adición) -->
      <div v-if="infoEdit.cuenta == null" class="search-fields">
        <div class="form-field">
          <label class="field-label">{{ labels.criterio }}</label>
          <div class="search-inputs">
            <md-field class="custom-field">
              <md-input v-model="critCuenta" :placeholder="labels.criterioCuenta" @input="buscaCuenta"></md-input>
            </md-field>
            <md-field class="custom-field">
              <md-input v-model="critDescripcion" :placeholder="labels.criterioDescripcion" @input="buscaDescripcion"></md-input>
            </md-field>
          </div>
        </div>
      </div>

      <!-- Campo de cuenta -->
      <div class="form-fields">
        <div class="form-field">
          <label class="field-label">{{ labels.cuenta }}</label>
          <div v-if="infoEdit.cuenta" class="display-value">
            {{ infoEdit.cuenta }}
          </div>
          <div v-else class="multi-select-container">
            <select multiple v-model="listadoCuentasDest" class="modern-select-multiple">
              <option v-for="(cuenta,idx) in listCuentasSelMul" 
                      :value="cuenta.cuenta" 
                      :key="idx+'-'+cuenta.id">
                {{ cuenta.cuenta }} - {{ cuenta.descripcion }}
              </option>
            </select>
            <div class="selection-count" v-if="listadoCuentasDest.length > 0">
              {{ labels.seleccionadas }}: {{ listadoCuentasDest.length }}
            </div>
          </div>
        </div>

        <!-- Campos adicionales (solo para edición) -->
        <template v-if="infoEdit.cuenta">
          <div class="form-field">
            <label class="field-label">{{ labels.description }}</label>
            <div class="display-value">
              {{ infoEdit.descripcion }}
            </div>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.valor }}</label>
            <md-field class="custom-field">
              <md-input v-model="infoEdit.valor"></md-input>
            </md-field>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.funcional }}</label>
            <md-field class="custom-field">
              <md-input v-model="infoEdit.funcional"></md-input>
            </md-field>
          </div>

          <div class="form-field">
            <label class="field-label">{{ labels.alterna }}</label>
            <md-field class="custom-field">
              <md-input v-model="infoEdit.alterna"></md-input>
            </md-field>
          </div>
        </template>
      </div>
    </md-dialog-content>

    <md-dialog-actions class="dialog-actions">
      <md-button class="md-raised cancel-btn" @click="closeModal">
        {{ labels.close }}
      </md-button>
      <md-button class="md-raised md-primary save-btn" @click="guardaAjuste">
        {{ labels.save }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import AjustesConsol from '../../services/AjustesConsol'

export default {
  name: "EditAjustesDest",
  props: ['showEdiAjustDest', 'infoEdit', 'listCuentas', 'listCuentasSelMul', 'codReporte', 'idCompania', 'vigencia', 'secuencia', 'tipo', 'tipo_ajuste'],
  data: () => ({
    critCuenta: "",
    critDescripcion: "",
    listadoCuentasDest: [],
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Editar ajuste",
          save: "Guardar",
          close: "Cerrar",
          criterio: "Criterio de búsqueda",
          criterioCuenta: "Buscar por cuenta...",
          criterioDescripcion: "Buscar por descripción...",
          cuenta: "Cuenta",
          description: "Descripción",
          valor: "Valor",
          funcional: "Funcional",
          alterna: "Alterna",
          seleccionadas: "Cuentas seleccionadas"
        }
      } else {
        return {
          title: "Edit setting",
          save: "Save",
          close: "Close",
          criterio: "Search criteria",
          criterioCuenta: "Search by account...",
          criterioDescripcion: "Search by description...",
          cuenta: "Account",
          description: "Description",
          valor: "Value",
          funcional: "Functional",
          alterna: "Alternate",
          seleccionadas: "Selected accounts"
        }
      }
    }
  },
  methods: {
    buscaCuenta() {
      const criterio = "^" + this.critCuenta
      if (this.critCuenta.length == 0) {
        this.listCuentasSelMul = this.listCuentas
      } else {
        this.listCuentasSelMul = this.listCuentas.filter(
          (cuenta) => cuenta.cuenta.match(criterio) > 0
        )
      }
    },
    buscaDescripcion() {
      if (this.critDescripcion.length == 0) {
        this.listCuentasSelMul = this.listCuentas
      } else {
        this.listCuentasSelMul = this.listCuentas.filter(
          (cuenta) => cuenta.descripcion.toUpperCase().indexOf(this.critDescripcion.toUpperCase()) >= 0
        )
      }
    },
    guardaAjuste() {
      if (this.infoEdit.valor === '') {
        this.infoEdit.valor = null
      }
      if (this.infoEdit.funcional === '') {
        this.infoEdit.funcional = null
      }
      if (this.infoEdit.alterna === '') {
        this.infoEdit.alterna = null
      }
      if (this.infoEdit.valor != null &&
        (this.infoEdit.funcional === null ||
          this.infoEdit.alterna === null)) {
        this.$toast.error("Funcional y Alterna no pueden ser nulos")
        return
      }

      if (this.infoEdit.valor === null &&
        (this.infoEdit.funcional != null ||
          this.infoEdit.alterna != null)) {
        this.$toast.error("Funcional y Alterna deben ser nulos")
        return
      }

      let form = {}
      if (this.infoEdit.cuenta) {
        form = {
          'id': this.infoEdit.id,
          'vigencia': this.infoEdit.vigencia,
          'companyId': this.infoEdit.id_compania,
          'valor': this.infoEdit.valor,
          'funcional': this.infoEdit.funcional,
          'alterna': this.infoEdit.alterna,
          'idUser': this.$store.state.userId,
        }
      } else {
        form = {
          'vigencia': this.vigencia,
          'secuencia': this.secuencia,
          'codReporte': this.codReporte,
          'companyId': this.idCompania,
          'tipo': this.tipo,
          'listadoCuentas': this.listadoCuentasDest,
          'idUser': this.$store.state.userId,
        }
      }

      AjustesConsol.updateAjusteDestino(form)
        .then((res) => {
          if (res.status == 200) {
            this.$toast.success(res.data.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setTimeout(() => {
            this.reloadTbl()
          }, 2000)
        })
    },
    closeModal() {
      this.$emit('closeModal', false)
    },
    reloadTbl() {
      let form = {
        'id': this.secuencia,
        'vigencia': this.vigencia,
        'companyId': this.idCompania
      }
      this.$emit('reloadTblDest', form)
    }
  }
}
</script>

<style scoped>
.custom-dialog {
  min-width: 500px;
  max-width: 600px;
  border-radius: 8px;
  margin: 0 auto;
}

.dialog-header {
  background: #34495e;
  color: white;
  padding: 20px 24px;
  border-bottom: 1px solid #2c3e50;
}

.header-title {
  font-size: 1.2rem;
  font-weight: 500;
}

.dialog-content {
  padding: 24px;
}

.search-fields {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ecf0f1;
}

.search-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-field {
  margin-bottom: 0;
}

.field-label {
  display: block;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.custom-field {
  margin: 0;
}

.display-value {
  background: #f8f9fa;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  color: #495057;
  font-size: 14px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.multi-select-container {
  position: relative;
}

.modern-select-multiple {
  width: 100%;
  min-height: 150px;
  padding: 10px 12px;
  border: 1px solid #bdc3c7;
  border-radius: 4px;
  background: white;
  font-size: 14px;
  color: #2c3e50;
  outline: none;
  transition: border-color 0.3s ease;
}

.modern-select-multiple:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

.modern-select-multiple option {
  padding: 8px 10px;
  border-bottom: 1px solid #f1f1f1;
}

.modern-select-multiple option:hover {
  background: #e3f2fd;
}

.modern-select-multiple option:checked {
  background: #3498db;
  color: white;
}

.selection-count {
  position: absolute;
  bottom: -25px;
  right: 0;
  font-size: 12px;
  color: #7f8c8d;
  font-style: italic;
}

.dialog-actions {
  padding: 16px 24px;
  border-top: 1px solid #ecf0f1;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn {
  background: #95a5a6 !important;
  color: white !important;
}

.save-btn {
  background: #3498db !important;
  color: white !important;
}

@media (max-width: 768px) {
  .custom-dialog {
    min-width: 90vw;
    margin: 10px;
  }
  
  .search-inputs {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .dialog-content {
    padding: 20px;
  }
  
  .dialog-actions {
    padding: 12px 20px;
    flex-direction: column;
  }
  
  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
</style>